/* eslint-disable */
import { useState, useRef } from 'react';
import * as XLSX from 'xlsx';

const inputStyle = {
  padding:'8px 10px', border:'1.5px solid #ddd', borderRadius:'8px',
  fontSize:'13px', color:'#333', background:'#fafafa',
  outline:'none', width:'100%', fontFamily:'inherit', boxSizing:'border-box'
};

function Modal({ show, onClose, title, children, footer }) {
  if (!show) return null;
  return (
    <div style={{ position:'fixed', inset:0, background:'rgba(0,0,0,0.5)', display:'flex', alignItems:'center', justifyContent:'center', zIndex:999, padding:'20px' }}>
      <div style={{ background:'white', borderRadius:'16px', width:'100%', maxWidth:'800px', maxHeight:'90vh', display:'flex', flexDirection:'column', boxShadow:'0 20px 60px rgba(0,0,0,0.3)' }}>
        <div style={{ display:'flex', justifyContent:'space-between', alignItems:'center', padding:'16px 24px', borderBottom:'1px solid #f0f4f8' }}>
          <h3 style={{ fontSize:'15px', color:'#1a3a5c', margin:0 }}>{title}</h3>
          <button onClick={onClose} style={{ background:'none', border:'none', fontSize:'20px', cursor:'pointer', color:'#888' }}>✕</button>
        </div>
        <div style={{ padding:'20px', overflowY:'auto', flex:1, display:'flex', flexDirection:'column', gap:'14px' }}>{children}</div>
        {footer && <div style={{ padding:'14px 20px', borderTop:'1px solid #f0f4f8', display:'flex', justifyContent:'flex-end', gap:'10px' }}>{footer}</div>}
      </div>
    </div>
  );
}

/**
 * Komponen tombol + modal import Excel
 * @param {Array}  columnMap - [{ excelHeader: 'Kode', field: 'kode', required: true }, ...]
 * @param {Function} onImport - async (items) => { ok, data } — panggil API bulk import
 * @param {String} label - teks tombol
 * @param {String} templateNote - catatan format kolom yang diharapkan
 */
function ImportExcel({ columnMap, onImport, label = '📥 Import Excel', templateNote }) {
  const [show, setShow]       = useState(false);
  const [rows, setRows]       = useState([]);
  const [fileName, setFileName] = useState('');
  const [importing, setImporting] = useState(false);
  const [hasil, setHasil]     = useState(null);
  const fileRef = useRef(null);

  function handleFile(e) {
    const file = e.target.files[0];
    if (!file) return;
    setFileName(file.name);
    setHasil(null);

    const reader = new FileReader();
    reader.onload = (evt) => {
      try {
        const data = new Uint8Array(evt.target.result);
        const workbook = XLSX.read(data, { type: 'array' });
        const sheetName = workbook.SheetNames[0];
        const sheet = workbook.Sheets[sheetName];
        const json = XLSX.utils.sheet_to_json(sheet, { defval: '' });

        // Debug: tampilkan kolom yang terdeteksi dari file
          if (json.length > 0) {
            console.log('Kolom terdeteksi di Excel:', Object.keys(json[0]));
          }

        // Mapping otomatis berdasarkan columnMap
        const mapped = json.map(row => {
            const obj = {};
            columnMap.forEach(col => {
              const target = col.excelHeader.toLowerCase().replace(/[\s._-]+/g,'');
              // Coba exact match dulu, kalau tidak ada coba partial match
              let key = Object.keys(row).find(k =>
                k.toLowerCase().replace(/[\s._-]+/g,'') === target
              );
              if (!key) {
                key = Object.keys(row).find(k =>
                  k.toLowerCase().replace(/[\s._-]+/g,'').includes(target) ||
                  target.includes(k.toLowerCase().replace(/[\s._-]+/g,''))
                );
              }
              obj[col.field] = key ? String(row[key]).trim() : '';
            });
            return obj;
          }).filter(r => columnMap.some(c => c.required) ? columnMap.filter(c=>c.required).every(c => r[c.field]) : true);

          setRows(mapped);
          setShow(true);
      } catch (err) {
        alert('❌ Gagal membaca file Excel: ' + err.message);
      }
    };
    reader.readAsArrayBuffer(file);
    e.target.value = '';
  }

  async function submitImport() {
    if (rows.length === 0) { alert('⚠️ Tidak ada data valid untuk diimport'); return; }
    setImporting(true);
    try {
      const result = await onImport(rows);
      if (result.ok) {
        setHasil({ sukses: true, pesan: result.data.message });
      } else {
        setHasil({ sukses: false, pesan: result.data.message });
      }
    } catch (err) {
      setHasil({ sukses: false, pesan: 'Gagal terhubung ke server' });
    } finally {
      setImporting(false);
    }
  }

  function tutupDanReset() {
    setShow(false);
    setRows([]);
    setFileName('');
    setHasil(null);
  }

  return (
    <>
      <button onClick={() => fileRef.current?.click()} style={{
        padding:'9px 16px', background:'white', color:'#1a3a5c',
        border:'1.5px solid #1a3a5c', borderRadius:'8px',
        fontSize:'13px', fontWeight:'600', cursor:'pointer', whiteSpace:'nowrap'
      }}>
        {label}
      </button>
      <input ref={fileRef} type="file" accept=".xlsx,.xls,.csv" onChange={handleFile} style={{ display:'none' }} />

      <Modal show={show} onClose={tutupDanReset} title="📥 Preview Import Excel"
        footer={hasil ? (
          <button onClick={tutupDanReset} style={{ padding:'9px 20px', background:'#1a3a5c', color:'white', border:'none', borderRadius:'8px', fontSize:'13px', fontWeight:'600', cursor:'pointer' }}>Selesai</button>
        ) : (
          <>
            <button onClick={tutupDanReset} disabled={importing} style={{ padding:'9px 16px', background:'white', color:'#333', border:'1.5px solid #ddd', borderRadius:'8px', fontSize:'13px', fontWeight:'600', cursor:'pointer' }}>Batal</button>
            <button onClick={submitImport} disabled={importing || rows.length===0} style={{ padding:'9px 16px', background: importing?'#aaa':'linear-gradient(135deg,#1e8449,#27ae60)', color:'white', border:'none', borderRadius:'8px', fontSize:'13px', fontWeight:'600', cursor: importing?'not-allowed':'pointer' }}>
              {importing ? '⏳ Mengimport...' : `✅ Import ${rows.length} Baris`}
            </button>
          </>
        )}>

        {hasil ? (
          <div style={{
            padding:'20px', borderRadius:'10px', textAlign:'center',
            background: hasil.sukses ? '#eafaf1' : '#fdedec',
          }}>
            <div style={{ fontSize:'40px', marginBottom:'10px' }}>{hasil.sukses ? '✅' : '❌'}</div>
            <p style={{ fontSize:'14px', color: hasil.sukses?'#1e8449':'#c0392b', fontWeight:'600', margin:0 }}>{hasil.pesan}</p>
          </div>
        ) : (
          <>
            <div style={{ display:'flex', justifyContent:'space-between', alignItems:'center', fontSize:'13px' }}>
              <span>📄 File: <strong>{fileName}</strong></span>
              <span style={{ color: rows.length>0?'#27ae60':'#e74c3c', fontWeight:'700' }}>
                {rows.length} baris valid ditemukan
              </span>
            </div>

            {templateNote && (
              <div style={{ background:'#f8fbff', border:'1px solid #e0e8f4', borderRadius:'8px', padding:'10px 14px', fontSize:'11px', color:'#666' }}>
                💡 {templateNote}
              </div>
            )}

            {rows.length === 0 ? (
              <div style={{ textAlign:'center', padding:'30px', color:'#e74c3c', fontSize:'13px' }}>
                ⚠️ Tidak ada baris valid. Pastikan nama kolom di Excel sesuai format yang diharapkan.
              </div>
            ) : (
              <div style={{ overflowX:'auto', maxHeight:'350px', overflowY:'auto', border:'1px solid #eee', borderRadius:'8px' }}>
                <table style={{ width:'100%', borderCollapse:'collapse' }}>
                  <thead style={{ position:'sticky', top:0 }}>
                    <tr style={{ background:'#f0f4f8' }}>
                      <th style={{ padding:'8px', fontSize:'11px', fontWeight:'700', color:'#444', border:'1px solid #ddd', textAlign:'center' }}>No.</th>
                      {columnMap.map(c=>(
                        <th key={c.field} style={{ padding:'8px', fontSize:'11px', fontWeight:'700', color:'#444', border:'1px solid #ddd', textAlign:'left' }}>{c.excelHeader}</th>
                      ))}
                    </tr>
                  </thead>
                  <tbody>
                    {rows.slice(0, 100).map((r,i)=>(
                      <tr key={i}>
                        <td style={{ padding:'6px 8px', fontSize:'12px', border:'1px solid #eee', textAlign:'center', color:'#888' }}>{i+1}</td>
                        {columnMap.map(c=>(
                          <td key={c.field} style={{ padding:'6px 8px', fontSize:'12px', border:'1px solid #eee' }}>{r[c.field] || <span style={{ color:'#ccc' }}>-</span>}</td>
                        ))}
                      </tr>
                    ))}
                  </tbody>
                </table>
                {rows.length > 100 && (
                  <div style={{ padding:'8px', textAlign:'center', fontSize:'11px', color:'#888', background:'#f8f9fa' }}>
                    ... dan {rows.length - 100} baris lainnya
                  </div>
                )}
              </div>
            )}
          </>
        )}
      </Modal>
    </>
  );
}

export default ImportExcel;